import styled from 'styled-components';
import PropTypes from 'prop-types';
import styleHelper from '@utils/styleHelper';
import { TextColors, Fonts, Spacings } from '@styles/index';

const H4 = styled.h4`
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.H4};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: ${({ color }) => color};
  margin: ${Spacings.SPACING_0B};
  @media (max-width: 70.95em) {
    font-size: 16px;
    line-height: 100%;
  }
  ${({ lineClamp }) =>
    lineClamp ? styleHelper.lineClampStyle(lineClamp) : null}
`;

export default H4;

H4.propTypes = {
  color: PropTypes.string,
  lineClamp: PropTypes.number
};

H4.defaultProps = {
  color: TextColors.BLACK,
  lineClamp: null
};
